import $ from 'jquery';

function openPopup(video) {
	const data = video.data();
	const id = data.videoId;
	video.magnificPopup({
		type: 'iframe',
        midClick: true,
        removalDelay: 300,
	}).magnificPopup('open');
}

function attachHandlers() {
	$('.open-video-modal').on('click', function(e) {
		e.preventDefault();
		openPopup($(this));
	});
}

export default attachHandlers;
